import { useState } from 'react'
import { followUpChoicesFor } from '@/logic/changes'
import { addDays, fmtDate, startOfWeek } from '@/logic/dates'
import type { DateStr, Task, TimeStr } from '@/types'
import { Button } from './Button'
import { ChoiceSheet } from './ConfirmSheet'

interface FollowUpSheetProps {
  open: boolean
  task: Pick<Task, 'kind'>
  today: DateStr
  onPick: (date: DateStr | null, time: TimeStr | null) => void
  onCancel: () => void
}

/** "Follow up when?", asked when Waiting is turned on: quick choices, and always a date and time of your own. */
export function FollowUpSheet({ open, task, today, onPick, onCancel }: FollowUpSheetProps) {
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  // a routine has no per-week exceptions, so its follow-up stays within its week
  const max = task.kind === 'routine' ? addDays(startOfWeek(today), 6) : undefined
  const choices = followUpChoicesFor(task, today).map((c) =>
    c.days === null ? { key: 'none', label: c.label } : { key: addDays(today, c.days), label: c.label, hint: fmtDate(addDays(today, c.days)) },
  )
  return (
    <ChoiceSheet open={open} heading="Follow up when?" choices={choices} onChoose={(k) => onPick(k === 'none' ? null : k, null)} onCancel={onCancel}>
      <div className="confirm__actions followup__custom">
        <label className="sr-only" htmlFor="follow-up-date">
          Follow-up date
        </label>
        <input id="follow-up-date" type="date" className="field__input" value={date} min={today} max={max} onChange={(e) => setDate(e.target.value)} />
        <label className="sr-only" htmlFor="follow-up-time">
          Follow-up time, optional
        </label>
        <input id="follow-up-time" type="time" className="field__input" value={time} step={300} onChange={(e) => setTime(e.target.value)} />
        <Button variant="secondary" disabled={!date} onClick={() => onPick(date, time || null)}>
          Use this
        </Button>
      </div>
    </ChoiceSheet>
  )
}
